export default __webpack_public_path__ + "static/media/franimg.73e8d25f.png";